// import React, { useEffect, useState, useMemo, useRef, useCallback } from 'react';
// import { createPortal } from 'react-dom';
// import { io } from 'socket.io-client';
// import axios from 'axios';
// import { Notify } from '../Utility/Notify';
// import { db_url } from '../Api/BaseUrl';
// import { ShowClientsActionsAdvanced } from './ShowClientsActionsAdvanced';

// const socket = io(db_url);
// const LIMIT  = 10;

// const detectType = (msg) => {
//   if (!msg) return 'general';
//   const m = msg.toLowerCase();
//   if (m.includes('comment') || m.includes('replied')) return 'comment';
//   if (m.includes('assign') || m.includes('task') || m.includes('deadline')) return 'assignment';
//   return 'general';
// };
// const getInitials = (name = '') =>
//   (name || 'U').split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
// const formatDate = (ds) => {
//   if (!ds) return 'Just now';
//   try {
//     const d = new Date(ds);
//     if (isNaN(d.getTime())) return 'Just now';
//     const diff = (Date.now() - d.getTime()) / 1000;
//     if (diff < 60)     return 'Just now';
//     if (diff < 3600)   return `${Math.floor(diff / 60)}m ago`;
//     if (diff < 86400)  return `${Math.floor(diff / 3600)}h ago`;
//     if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
//     return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
//   } catch { return 'Just now'; }
// };
// const TYPE = {
//   comment:    { label: 'Comment',    bg: '#DCFCE7', color: '#16A34A', dot: '#16A34A' },
//   assignment: { label: 'Task',       bg: '#FEF3C7', color: '#D97706', dot: '#F59E0B' },
//   general:    { label: 'General',    bg: '#DBEAFE', color: '#1D4ED8', dot: '#3B82F6' },
// };
// const avatarBg = (name = '') => {
//   const p = ['#0D47A1','#1565C0','#1976D2','#16A34A','#D97706','#DC2626','#7C3AED','#DB2777','#0891B2'];
//   let h = 0;
//   for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) % p.length;
//   return p[h];
// };

// const IcoBell    = ({ s = 20 }) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>;
// const IcoComment = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>;
// const IcoTask    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>;
// const IcoGeneral = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>;
// const IcoCheck   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>;
// const IcoCheckAll= () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12"/><polyline points="14 6 3 17"/></svg>;
// const IcoTrash   = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2"/></svg>;
// const IcoClose   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
// const IcoCreated = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>;
// const IcoSpin    = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{animation:'nb-spin .8s linear infinite'}}><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>;
// const typeIcon = (t) => t === 'comment' ? <IcoComment /> : t === 'assignment' ? <IcoTask /> : <IcoGeneral />;

// const CSS = `
//   @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');
//   .nb-wrap * { box-sizing:border-box; font-family:'DM Sans',sans-serif; }
//   @keyframes nb-fadein { from{opacity:0;transform:translateY(-8px) scale(0.97)} to{opacity:1;transform:none} }
//   @keyframes nb-shake  { 0%,100%{transform:rotate(0)} 20%{transform:rotate(14deg)} 40%{transform:rotate(-14deg)} 60%{transform:rotate(10deg)} 80%{transform:rotate(-6deg)} }
//   @keyframes nb-pulse  { 0%,100%{transform:scale(1);opacity:1} 50%{transform:scale(1.5);opacity:.5} }
//   @keyframes nb-blink  { 0%,100%{opacity:1} 50%{opacity:.3} }
//   @keyframes nb-float  { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-8px)} }
//   @keyframes nb-spin   { to{transform:rotate(360deg)} }
//   @keyframes nb-slide  { from{opacity:0;transform:translateY(6px)} to{opacity:1;transform:none} }
//   @keyframes nb-popin  { from{opacity:0;transform:scale(0.85)} to{opacity:1;transform:scale(1)} }
//   .nb-bell { position:relative;width:42px;height:42px;border-radius:12px;border:none;background:transparent;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#1C2340;transition:all .2s; }
//   .nb-bell:hover { background:rgba(13,71,161,.08);color:#0D47A1; }
//   .nb-bell.shake { animation:nb-shake .6s ease; }
//   .nb-badge { position:absolute;top:4px;right:4px;min-width:18px;height:18px;border-radius:9px;background:#EF4444;color:#fff;font-size:10px;font-weight:700;padding:0 5px;display:flex;align-items:center;justify-content:center;border:2px solid #fff;line-height:1; }
//   .nb-panel { position:fixed;z-index:99999;width:400px;max-width:calc(100vw - 32px);max-height:calc(100vh - 80px);background:#fff;border-radius:18px;box-shadow:0 20px 60px rgba(0,0,0,.15),0 4px 16px rgba(0,0,0,.08);border:1px solid #E8EAF0;display:flex;flex-direction:column;overflow:hidden;animation:nb-fadein .22s cubic-bezier(.34,1.1,.64,1) both; }
//   .nb-header { background:linear-gradient(135deg,#0D47A1,#1565C0);padding:16px 18px 14px;display:flex;align-items:center;justify-content:space-between;flex-shrink:0; }
//   .nb-header-left { display:flex;align-items:center;gap:10px; }
//   .nb-header-title { font-size:15px;font-weight:700;color:#fff; }
//   .nb-header-sub   { font-size:11px;color:rgba(255,255,255,.65);margin-top:1px; }
//   .nb-new-pill { display:flex;align-items:center;gap:5px;background:rgba(255,255,255,.18);backdrop-filter:blur(8px);color:#fff;padding:4px 10px;border-radius:20px;font-size:11px;font-weight:700; }
//   .nb-new-dot  { width:6px;height:6px;border-radius:50%;background:#4ADE80;animation:nb-blink 1.5s infinite; }
//   .nb-close-btn { width:28px;height:28px;border-radius:8px;border:none;cursor:pointer;background:rgba(255,255,255,.15);color:#fff;display:flex;align-items:center;justify-content:center;transition:all .15s; }
//   .nb-close-btn:hover { background:rgba(255,255,255,.3); }
//   .nb-stats { display:flex;align-items:center;gap:12px;padding:10px 16px;background:#F0F4FF;border-bottom:1px solid #E8EAF0;flex-shrink:0; }
//   .nb-stat-item { display:flex;align-items:center;gap:5px; }
//   .nb-stat-num  { font-size:15px;font-weight:800;color:#0D47A1; }
//   .nb-stat-lbl  { font-size:11px;color:#64748B;font-weight:500; }
//   .nb-stat-sep  { width:1px;height:16px;background:#CBD5E1; }
//   .nb-tabs { display:flex;border-bottom:1px solid #F0F2F8;flex-shrink:0;background:#FAFBFD; }
//   .nb-tab  { flex:1;padding:10px 4px;border:none;background:transparent;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:4px;font-family:'DM Sans',sans-serif;font-size:11px;font-weight:600;color:#7B829A;border-bottom:2px solid transparent;transition:all .15s;white-space:nowrap; }
//   .nb-tab:hover  { color:#1C2340;background:rgba(13,71,161,.04); }
//   .nb-tab.active { color:#0D47A1;border-bottom-color:#0D47A1;background:rgba(13,71,161,.04); }
//   .nb-tab-count  { min-width:16px;height:16px;border-radius:8px;padding:0 4px;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700; }
//   .nb-actions { display:flex;align-items:center;justify-content:space-between;padding:8px 14px;background:#F7F8FC;border-bottom:1px solid #F0F2F8;flex-shrink:0; }
//   .nb-action-btn { display:flex;align-items:center;gap:5px;padding:5px 10px;border-radius:8px;border:none;cursor:pointer;font-family:'DM Sans',sans-serif;font-size:12px;font-weight:600;background:transparent;transition:all .15s; }
//   .nb-action-btn.read  { color:#0D47A1; } .nb-action-btn.read:hover  { background:rgba(13,71,161,.08); }
//   .nb-action-btn.clear { color:#EF4444; } .nb-action-btn.clear:hover { background:rgba(239,68,68,.08); }
//   .nb-list { flex:1;overflow-y:auto;padding:10px;scrollbar-width:thin;scrollbar-color:#E2E8F0 transparent; }
//   .nb-list::-webkit-scrollbar { width:4px; }
//   .nb-list::-webkit-scrollbar-thumb { background:#E2E8F0;border-radius:4px; }
//   .nb-item { display:flex;align-items:flex-start;gap:11px;padding:12px 13px;border-radius:12px;border:1.5px solid #F1F3F9;margin-bottom:7px;cursor:pointer;transition:all .18s;position:relative;background:#fff;animation:nb-slide .2s ease both; }
//   .nb-item:last-child { margin-bottom:0; }
//   .nb-item:hover { border-color:#D1D9F0;background:#F9FAFF;transform:translateX(3px); }
//   .nb-item.unread { background:#F7F9FF;border-color:#DBEAFE; }
//   .nb-item.unread:hover { background:#EEF3FF;border-color:#BFDBFE; }
//   .nb-item.unread::before { content:'';position:absolute;left:0;top:8px;bottom:8px;width:3px;border-radius:0 3px 3px 0;background:#0D47A1; }
//   .nb-avatar { width:40px;height:40px;border-radius:12px;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;color:#fff;letter-spacing:.5px; }
//   .nb-item-body { flex:1;min-width:0; }
//   .nb-item-top  { display:flex;align-items:center;gap:6px;margin-bottom:4px;flex-wrap:wrap; }
//   .nb-item-name { font-size:13px;font-weight:700;color:#0F172A; }
//   .nb-type-pill { display:inline-flex;align-items:center;gap:3px;padding:2px 8px;border-radius:20px;font-size:10px;font-weight:700;letter-spacing:.04em; }
//   .nb-item-msg  { font-size:12.5px;color:#475569;line-height:1.5;margin-bottom:6px; }
//   .nb-item-msg.unread { color:#1E293B;font-weight:500; }
//   .nb-item-foot { display:flex;align-items:center;justify-content:space-between; }
//   .nb-item-time { font-size:11px;color:#94A3B8;font-weight:500; }
//   .nb-item-time.unread { color:#0D47A1;font-weight:600; }
//   .nb-unread-dot { width:8px;height:8px;border-radius:50%;flex-shrink:0;margin-top:4px;animation:nb-pulse 2s infinite; }
//   .nb-read-tick  { width:20px;height:20px;border-radius:50%;background:#DCFCE7;color:#16A34A;display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-top:2px; }
//   .nb-load-more { display:flex;align-items:center;justify-content:center;gap:8px;padding:12px;color:#0D47A1;font-size:12px;font-weight:600; }
//   .nb-empty { display:flex;flex-direction:column;align-items:center;justify-content:center;padding:44px 20px;color:#94A3B8;text-align:center;animation:nb-float 3s ease-in-out infinite; }
//   .nb-empty-title { font-size:14px;font-weight:600;color:#64748B;margin:12px 0 4px; }
//   .nb-empty-sub   { font-size:12px;color:#94A3B8; }
//   .nb-footer { padding:9px 16px;border-top:1px solid #F0F2F8;background:#FAFBFD;flex-shrink:0;text-align:center;font-size:11px;color:#94A3B8;font-weight:500; }

//   /* ── Transferred Toast ── */
//   .nb-transferred-overlay { position:fixed;inset:0;z-index:999999;display:flex;align-items:center;justify-content:center;background:rgba(15,23,42,0.45);backdrop-filter:blur(4px); }
//   .nb-transferred-card { background:#fff;border-radius:20px;padding:32px 28px;max-width:360px;width:calc(100vw - 40px);text-align:center;box-shadow:0 24px 60px rgba(0,0,0,.18);animation:nb-popin .25s cubic-bezier(.34,1.2,.64,1) both; }
//   .nb-transferred-icon { width:64px;height:64px;border-radius:50%;background:linear-gradient(135deg,#FEF3C7,#FDE68A);display:flex;align-items:center;justify-content:center;margin:0 auto 16px; }
//   .nb-transferred-title { font-size:16px;font-weight:800;color:#1E293B;margin-bottom:8px; }
//   .nb-transferred-msg   { font-size:13px;color:#64748B;line-height:1.55;margin-bottom:20px; }
//   .nb-transferred-btn   { display:inline-flex;align-items:center;justify-content:center;gap:6px;padding:10px 24px;border-radius:10px;border:none;cursor:pointer;background:#0D47A1;color:#fff;font-family:'DM Sans',sans-serif;font-size:13px;font-weight:700;transition:all .15s; }
//   .nb-transferred-btn:hover { background:#1330A6; }
//   .nb-checking-overlay { position:fixed;inset:0;z-index:999999;display:flex;align-items:center;justify-content:center;background:rgba(15,23,42,0.3);backdrop-filter:blur(2px); }
//   .nb-checking-card { background:#fff;border-radius:14px;padding:20px 28px;display:flex;align-items:center;gap:12px;box-shadow:0 8px 32px rgba(0,0,0,.12); }
// `;

// const EmptyState = ({ tab }) => {
//   const msgs = [
//     { t:"You're all caught up!",    s:"No notifications yet" },
//     { t:"No comment notifications", s:"Comments will appear here" },
//     { t:"No task notifications",    s:"Assignments will appear here" },
//     { t:"No activity from you yet", s:"Actions you took will show here" },
//   ];
//   const m = msgs[tab] || msgs[0];
//   return (
//     <div className="nb-empty">
//       <div style={{ fontSize:40, opacity:.2 }}>🔔</div>
//       <p className="nb-empty-title">{m.t}</p>
//       <p className="nb-empty-sub">{m.s}</p>
//     </div>
//   );
// };

// // ── Transferred Lead Card ────────────────────────────────────────────────────
// const TransferredCard = ({ leadName, onClose }) => createPortal(
//   <div className="nb-transferred-overlay" onClick={onClose}>
//     <div className="nb-transferred-card" onClick={e => e.stopPropagation()}>
//       <div className="nb-transferred-icon">
//         <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#D97706" strokeWidth="2" strokeLinecap="round">
//           <path d="M17 16l4-4-4-4"/>
//           <path d="M3 12h18"/>
//           <path d="M7 8l-4 4 4 4"/>
//         </svg>
//       </div>
//       <div className="nb-transferred-title">Lead Transferred</div>
//       <div className="nb-transferred-msg">
//         {leadName
//           ? <><strong style={{color:'#1E293B'}}>{leadName}</strong> has been</>
//           : 'This lead has been'
//         }
//         {' '}transferred from you to another sales representative and is no longer in your pipeline.
//       </div>
//       <button className="nb-transferred-btn" onClick={onClose}>
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
//         Got it
//       </button>
//     </div>
//   </div>,
//   document.body
// );

// // ── Checking Overlay ─────────────────────────────────────────────────────────
// const CheckingOverlay = () => createPortal(
//   <div className="nb-checking-overlay">
//     <div className="nb-checking-card">
//       <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0D47A1" strokeWidth="2.5" style={{animation:'nb-spin .8s linear infinite'}}>
//         <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
//       </svg>
//       <span style={{fontSize:13, fontWeight:600, color:'#1E293B', fontFamily:"'DM Sans',sans-serif"}}>Checking lead...</span>
//     </div>
//   </div>,
//   document.body
// );

// // ─────────────────────────────────────────────────────────────────────────────
// const NotificationBell = () => {
//   const [notifications,    setNotifications]    = useState([]);
//   const [unreadCount,      setUnreadCount]      = useState(0);
//   const [open,             setOpen]             = useState(false);
//   const [selectedLead,     setSelectedLead]     = useState(null);
//   const [shake,            setShake]            = useState(false);
//   const [activeTab,        setActiveTab]        = useState(0);
//   const [panelPos,         setPanelPos]         = useState({ top:0, right:16 });
//   const [currentPage,      setCurrentPage]      = useState(1);
//   const [totalResults,     setTotalResults]     = useState(0);
//   const [hasNextPage,      setHasNextPage]      = useState(false);
//   const [loadingMore,      setLoadingMore]      = useState(false);
//   const [initialLoading,   setInitialLoading]   = useState(false);
//   const [checking,         setChecking]         = useState(false);
//   const [transferredLead,  setTransferredLead]  = useState(null);

//   const bellRef  = useRef(null);
//   const panelRef = useRef(null);
//   const listRef  = useRef(null);

//   const userRef = useRef(null);
//   if (!userRef.current) {
//     userRef.current = JSON.parse(localStorage.getItem('user') || '{}');
//   }

//   const uid        = userRef.current?.data?._id;
//   const role       = userRef.current?.data?.role;
//   const token      = userRef.current?.token || userRef.current?.data?.token || '';

//   // ── Role flags ──────────────────────────────────────────────────────────────
//   const isAdmin    = role === 'Admin';
//   const isMarketer = role === 'Marketer';

//   // ── Marketer channels: مصفوفة من الـ ids ────────────────────────────────────
//   // بيدعم لو الـ channels عبارة عن objects { _id, name } أو strings مباشرة
//   const marketerChannels = useMemo(() => {
//     const raw = userRef.current?.data?.channels || [];
//     return raw.map(c => (typeof c === 'object' && c !== null ? c._id || c : c)).filter(Boolean);
//   }, []);

//   // ── Build URL حسب الـ role ────────────────────────────────────────────────
//   const buildUrl = useCallback((page) => {
//     const base = `${db_url}api/v1/Notification?page=${page}&limit=${LIMIT}`;

//     if (isAdmin) {
//       // أدمن يشوف كل النوتيفيكيشنز
//       return base;
//     }

//     if (isMarketer && marketerChannels.length > 0) {
//       // ماركتير يشوف النوتيفيكيشنز الخاصة بـ leads channels بتاعته بس
//       const ids = marketerChannels.join(',');
//       return `${base}&marketerChannels=${ids}`;
//     }

//     // باقي الـ roles → بالـ receiver بس
//     return `${base}&receiver=${uid}`;
//   }, [isAdmin, isMarketer, marketerChannels, uid]);

//   // ── Fetch page 1 ─────────────────────────────────────────────────────────
//   const fetchPage1 = useCallback(async () => {
//     setInitialLoading(true);
//     try {
//       const notifUrl  = buildUrl(1);

//       // Unread URL نفس المنطق
//       let unreadUrl;
//       if (isAdmin) {
//         unreadUrl = `${db_url}api/v1/Notification?page=1&limit=1&isRead=false`;
//       } else if (isMarketer && marketerChannels.length > 0) {
//         const ids = marketerChannels.join(',');
//         unreadUrl = `${db_url}api/v1/Notification?page=1&limit=1&isRead=false&marketerChannels=${ids}`;
//       } else {
//         unreadUrl = `${db_url}api/v1/Notification?page=1&limit=1&isRead=false&receiver=${uid}`;
//       }

//       const [res, unreadRes] = await Promise.all([
//         axios.get(notifUrl),
//         axios.get(unreadUrl),
//       ]);

//       const body = res.data;
//       const nots = (body?.data || []).filter(n => n?.message);
//       const pg   = body?.pagination || {};

//       setNotifications(nots);
//       setCurrentPage(1);
//       setTotalResults(pg.totalResults || nots.length);
//       setHasNextPage(pg.hasNextPage || false);

//       const realUnread =
//         (pg?.unreadCount !== undefined ? pg.unreadCount : null) ??
//         (unreadRes?.data?.pagination?.totalResults ?? null) ??
//         nots.filter(n => !n.isRead).length;
//       setUnreadCount(realUnread);

//     } catch (e) {
//       console.error('[NB] fetch error:', e);
//       setNotifications([]);
//     } finally {
//       setInitialLoading(false);
//     }
//   }, [buildUrl, isAdmin, isMarketer, marketerChannels, uid]);

//   useEffect(() => { fetchPage1(); }, [fetchPage1]);

//   // ── Load more ─────────────────────────────────────────────────────────────
//   const loadMore = useCallback(async () => {
//     if (loadingMore || !hasNextPage) return;
//     setLoadingMore(true);
//     try {
//       const res  = await axios.get(buildUrl(currentPage + 1));
//       const body = res.data;
//       const newN = (body?.data || []).filter(n => n?.message);
//       const pg   = body?.pagination || {};
//       setNotifications(prev => {
//         const ids = new Set(prev.map(n => n._id));
//         return [...prev, ...newN.filter(n => !ids.has(n._id))];
//       });
//       setCurrentPage(p => p + 1);
//       setTotalResults(pg.totalResults || 0);
//       setHasNextPage(pg.hasNextPage || false);
//     } catch {}
//     finally { setLoadingMore(false); }
//   }, [loadingMore, hasNextPage, currentPage, buildUrl]);

//   // ── Scroll to load more ───────────────────────────────────────────────────
//   const handleScroll = useCallback(() => {
//     const el = listRef.current;
//     if (!el) return;
//     if (el.scrollTop + el.clientHeight >= el.scrollHeight - 100 && hasNextPage && !loadingMore)
//       loadMore();
//   }, [hasNextPage, loadingMore, loadMore]);

//   useEffect(() => {
//     const el = listRef.current;
//     if (!el) return;
//     el.addEventListener('scroll', handleScroll, { passive: true });
//     return () => el.removeEventListener('scroll', handleScroll);
//   }, [handleScroll, open]);

//   // ── Socket: real-time notifications ──────────────────────────────────────
//   useEffect(() => {
//     const handler = (data) => {
//       if (!data?.message) return;

//       // ── للماركتير: تحقق إن الـ notification دي خاصة بـ lead في channels بتاعته
//       if (isMarketer && marketerChannels.length > 0) {
//         const leadChannel = data?.lead?.chanel;
//         if (leadChannel) {
//           const channelId = typeof leadChannel === 'object' ? leadChannel._id || leadChannel : leadChannel;
//           const isMyChannel = marketerChannels.some(
//             c => c.toString() === channelId.toString()
//           );
//           if (!isMyChannel) return; // مش channel بتاعته → تجاهل
//         }
//       }

//       const isSender = data?.userdoaction?._id === uid;
//       if (!isSender) {
//         setUnreadCount(p => p + 1);
//         setShake(true);
//         setTimeout(() => setShake(false), 700);
//       } else {
//         data.isRead = true;
//       }
//       setNotifications(p => [data, ...p.filter(n => n._id !== data._id)]);
//       setTotalResults(p => p + 1);
//     };
//     socket.on('newNotification', handler);
//     return () => socket.off('newNotification', handler);
//   }, [uid, isMarketer, marketerChannels]);

//   // ── Close panel on outside click ─────────────────────────────────────────
//   useEffect(() => {
//     if (!open) return;
//     const h = (e) => {
//       if (panelRef.current && !panelRef.current.contains(e.target) &&
//           bellRef.current  && !bellRef.current.contains(e.target)) setOpen(false);
//     };
//     document.addEventListener('mousedown', h);
//     return () => document.removeEventListener('mousedown', h);
//   }, [open]);

//   // ── Open panel ────────────────────────────────────────────────────────────
//   const openPanel = () => {
//     if (bellRef.current) {
//       const r = bellRef.current.getBoundingClientRect();
//       setPanelPos({ top: r.bottom + 8, right: Math.max(16, window.innerWidth - r.right) });
//     }
//     setOpen(o => !o);
//     setActiveTab(0);
//   };

//   // ── Filtered notifications per tab ───────────────────────────────────────
//   // الـ Backend بيرجع البيانات المفلترة بالفعل حسب الـ role
//   // الـ Frontend بيعمل sub-filter للـ tabs بس
//   const filtered = useMemo(() => {
//     if (!Array.isArray(notifications)) return [];

//     // للأدمن: يشوف الكل
//     // للماركتير: الـ backend رجّع الصح، مفيش فلتر إضافي هنا
//     // لباقي الـ roles: الـ backend رجّع بالـ receiver، مفيش فلتر إضافي
//     const base = notifications;

//     switch (activeTab) {
//       case 1: return base.filter(n => detectType(n.message) === 'comment');
//       case 2: return base.filter(n => detectType(n.message) === 'assignment');
//       case 3: return base.filter(n => n?.userdoaction?._id === uid);
//       default: return base;
//     }
//   }, [notifications, activeTab, uid]);

//   // ── Tab counts ────────────────────────────────────────────────────────────
//   const counts = useMemo(() => {
//     const base = notifications;
//     return {
//       all:         base.length,
//       comments:    base.filter(n => detectType(n.message) === 'comment').length,
//       assignments: base.filter(n => detectType(n.message) === 'assignment').length,
//       created:     base.filter(n => n?.userdoaction?._id === uid).length,
//     };
//   }, [notifications, uid]);

//   // ── Mark single as read ───────────────────────────────────────────────────
//   const markAsRead = async (id) => {
//     const notif = notifications.find(n => n._id === id);
//     if (!notif || notif.isRead) return;
//     // الماركتير ممكن يقرأ أي notification في نطاق channels بتاعته
//     if (!isAdmin && !isMarketer && notif?.receiver?._id !== uid) return;
//     try {
//       await axios.put(`${db_url}api/v1/Notification/read/${id}`);
//       setNotifications(p => p.map(n => n._id === id ? { ...n, isRead: true } : n));
//       setUnreadCount(p => Math.max(0, p - 1));
//     } catch { Notify('error', 'Failed', 'error'); }
//   };

//   // ── Click notification item ───────────────────────────────────────────────
//   const handleNotifClick = async (notif) => {
//     markAsRead(notif._id);

//     const lead = notif?.lead;
//     if (!lead?._id) return;

//     // أدمن وماركتير → فتح اللييد مباشرة (الـ backend اتحقق بالفعل إنها في نطاقه)
//     if (isAdmin || isMarketer) {
//       setSelectedLead(lead);
//       setOpen(false);
//       return;
//     }

//     // باقي الـ roles → تحقق من الـ ownership
//     setChecking(true);
//     setOpen(false);

//     try {
//       const res = await axios.get(
//         `${db_url}api/v1/users/sales/checknotifcationbeforeopen/${lead._id}/${uid}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       const leadData = res.data?.data;
//       setChecking(false);
//       setSelectedLead(leadData || lead);
//     } catch (err) {
//       setChecking(false);
//       if (err?.response?.status === 403) {
//         setTransferredLead({ name: lead?.name || '' });
//       } else {
//         console.error('[NB] lead check error:', err);
//         setSelectedLead(lead);
//       }
//     }
//   };

//   // ── Mark all read ─────────────────────────────────────────────────────────
//   const markAllRead = async () => {
//     try {
//       let payload = {};

//       if (isMarketer && marketerChannels.length > 0) {
//         // الماركتير يمرر الـ channels عشان الـ backend يعرف إيه اللي يعمله read
//         payload = { marketerChannels: marketerChannels.join(',') };
//       } else if (!isAdmin) {
//         payload = { receiver: uid };
//       }

//       await axios.put(`${db_url}api/v1/Notification/mark-all-read`, payload);
//       setNotifications(p => p.map(n => ({ ...n, isRead: true })));
//       setUnreadCount(0);
//       Notify('success', 'All marked as read', 'success');
//     } catch { Notify('error', 'Failed', 'error'); }
//   };

//   // ── Clear read ────────────────────────────────────────────────────────────
//   const clearRead = async () => {
//     try {
//       let payload = {};

//       if (isMarketer && marketerChannels.length > 0) {
//         payload = { marketerChannels: marketerChannels.join(',') };
//       } else if (!isAdmin) {
//         payload = { receiver: uid };
//       }

//       await axios.delete(`${db_url}api/v1/Notification/clear`, { data: payload });

//       // حذف الـ read notifications من الـ state
//       if (isMarketer) {
//         setNotifications(p => p.filter(n => !n.isRead));
//       } else {
//         setNotifications(p => p.filter(n => n.receiver?._id !== uid || !n.isRead));
//       }

//       Notify('success', 'Cleared', 'success');
//     } catch { Notify('error', 'Failed', 'error'); }
//   };

//   // ── Tabs config ───────────────────────────────────────────────────────────
//   const TABS = [
//     { label:'All',         count:counts.all,         bg:'#DBEAFE', color:'#1D4ED8', icon:<IcoBell s={13}/> },
//     { label:'Comments',    count:counts.comments,    bg:'#DCFCE7', color:'#16A34A', icon:<IcoComment/> },
//     { label:'Assignments', count:counts.assignments, bg:'#FEF3C7', color:'#D97706', icon:<IcoTask/> },
//     { label:'Created',     count:counts.created,     bg:'#F3E8FF', color:'#7C3AED', icon:<IcoCreated/> },
//   ];

//   // هل يظهر زر الـ actions (mark all / clear)؟
//   // للماركتير يظهر زي باقي الـ roles
//   const showActions = !isAdmin && activeTab === 0 && filtered.length > 0;

//   return (
//     <div className="nb-wrap">
//       <style>{CSS}</style>

//       {/* ── Bell button ── */}
//       <button ref={bellRef} className={`nb-bell ${shake ? 'shake' : ''}`} onClick={openPanel} title="Notifications">
//         <IcoBell s={20} />
//         {unreadCount > 0 && <span className="nb-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>}
//       </button>

//       {/* ── Panel ── */}
//       {open && createPortal(
//         <div ref={panelRef} className="nb-panel" style={{ top:panelPos.top, right:panelPos.right }}>

//           <div className="nb-header">
//             <div className="nb-header-left">
//               <IcoBell s={18} />
//               <div>
//                 <div className="nb-header-title">Notifications</div>
//                 <div className="nb-header-sub">
//                   {isMarketer ? 'My Channels Activity' : 'Activity Center'}
//                 </div>
//               </div>
//             </div>
//             <div style={{ display:'flex', alignItems:'center', gap:8 }}>
//               {unreadCount > 0 && (
//                 <div className="nb-new-pill"><span className="nb-new-dot"/>{unreadCount} New</div>
//               )}
//               <button className="nb-close-btn" onClick={() => setOpen(false)}><IcoClose/></button>
//             </div>
//           </div>

//           <div className="nb-stats">
//             <div className="nb-stat-item">
//               <span className="nb-stat-num">{totalResults}</span>
//               <span className="nb-stat-lbl">Total</span>
//             </div>
//             <div className="nb-stat-sep"/>
//             <div className="nb-stat-item">
//               <span className="nb-stat-num" style={{color:'#EF4444'}}>{unreadCount}</span>
//               <span className="nb-stat-lbl">Unread</span>
//             </div>
//             <div className="nb-stat-sep"/>
//             <div className="nb-stat-item">
//               <span className="nb-stat-num" style={{color:'#16A34A'}}>{totalResults - unreadCount}</span>
//               <span className="nb-stat-lbl">Read</span>
//             </div>
//             <div style={{flex:1}}/>
//             <div style={{fontSize:11, color:'#94A3B8'}}>{notifications.length} loaded</div>
//           </div>

//           <div className="nb-tabs">
//             {TABS.map((t, i) => (
//               <button key={i} className={`nb-tab ${activeTab === i ? 'active' : ''}`} onClick={() => setActiveTab(i)}>
//                 {t.icon} {t.label}
//                 {t.count > 0 && (
//                   <span className="nb-tab-count" style={{background:t.bg, color:t.color}}>{t.count}</span>
//                 )}
//               </button>
//             ))}
//           </div>

//           {showActions && (
//             <div className="nb-actions">
//               <button className="nb-action-btn read"  onClick={markAllRead}><IcoCheckAll/> Mark all read</button>
//               <button className="nb-action-btn clear" onClick={clearRead}><IcoTrash/> Clear read</button>
//             </div>
//           )}

//           <div className="nb-list" ref={listRef}>
//             {initialLoading ? (
//               <div className="nb-load-more"><IcoSpin/> Loading...</div>
//             ) : filtered.length === 0 ? (
//               <EmptyState tab={activeTab} />
//             ) : (
//               <>
//                 {filtered.map(notif => {
//                   if (!notif?.message) return null;
//                   const t      = detectType(notif.message);
//                   const cfg    = TYPE[t];
//                   const isRead = notif.isRead;
//                   const bg     = avatarBg(notif?.userdoaction?.name || '');
//                   return (
//                     <div
//                       key={notif._id || Math.random()}
//                       className={`nb-item ${!isRead ? 'unread' : ''}`}
//                       onClick={() => handleNotifClick(notif)}
//                     >
//                       <div className="nb-avatar" style={{background: isRead ? '#E2E8F0' : bg, color: isRead ? '#64748B' : '#fff'}}>
//                         {getInitials(notif?.userdoaction?.name)}
//                       </div>
//                       <div className="nb-item-body">
//                         <div className="nb-item-top">
//                           <span className="nb-item-name">{notif?.userdoaction?.name || 'System'}</span>
//                           <span className="nb-type-pill" style={{background:cfg.bg, color:cfg.color}}>
//                             {typeIcon(t)} {cfg.label}
//                           </span>
//                         </div>
//                         <div className={`nb-item-msg ${!isRead ? 'unread' : ''}`}>{notif.message}</div>
//                         {notif?.lead?.name && (
//                           <div style={{display:'flex',alignItems:'center',gap:4,marginTop:4}}>
//                             <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
//                             <span style={{fontSize:11,color:'#94A3B8',fontWeight:500}}>{notif.lead.name}</span>
//                             <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#CBD5E1" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
//                             <span style={{fontSize:11,color:'#60A5FA',fontWeight:600,cursor:'pointer'}}>Open lead</span>
//                           </div>
//                         )}
//                         <div className="nb-item-foot">
//                           <span className={`nb-item-time ${!isRead ? 'unread' : ''}`}>{formatDate(notif.createdAt)}</span>
//                         </div>
//                       </div>
//                       {isRead
//                         ? <div className="nb-read-tick"><IcoCheck/></div>
//                         : <div className="nb-unread-dot" style={{background:cfg.dot}}/>
//                       }
//                     </div>
//                   );
//                 })}
//                 {loadingMore && <div className="nb-load-more"><IcoSpin/> Loading more...</div>}
//                 {!hasNextPage && notifications.length > 0 && (
//                   <div style={{textAlign:'center',padding:'12px 0',fontSize:11,color:'#CBD5E1',fontWeight:500}}>
//                     All {totalResults} notifications loaded
//                   </div>
//                 )}
//               </>
//             )}
//           </div>

//           {filtered.length > 0 && (
//             <div className="nb-footer">
//               Showing {notifications.length} of {totalResults} · {unreadCount} unread
//             </div>
//           )}

//         </div>,
//         document.body
//       )}

//       {/* ── Checking overlay ── */}
//       {checking && <CheckingOverlay />}

//       {/* ── Transferred card ── */}
//       {transferredLead && (
//         <TransferredCard
//           leadName={transferredLead.name}
//           onClose={() => setTransferredLead(null)}
//         />
//       )}

//       {/* ── Lead modal ── */}
//       {selectedLead && selectedLead._id && (
//         <ShowClientsActionsAdvanced
//           user={selectedLead}
//           leadid={selectedLead._id}
//           onClose={() => setSelectedLead(null)}
//         />
//       )}
//     </div>
//   );
// };

// export default NotificationBell;















import React, { useEffect, useState, useMemo, useRef, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { io } from 'socket.io-client';
import axios from 'axios';
import { Notify } from '../Utility/Notify';
import { db_url } from '../Api/BaseUrl';
import { ShowClientsActionsAdvanced } from './ShowClientsActionsAdvanced';

const socket = io(db_url);
const LIMIT  = 10;

const detectType = (msg) => {
  if (!msg) return 'general';
  const m = msg.toLowerCase();
  if (m.includes('comment') || m.includes('replied')) return 'comment';
  if (m.includes('assign') || m.includes('task') || m.includes('deadline')) return 'assignment';
  return 'general';
};
const getInitials = (name = '') =>
  (name || 'U').split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
const formatDate = (ds) => {
  if (!ds) return 'Just now';
  try {
    const d = new Date(ds);
    if (isNaN(d.getTime())) return 'Just now';
    const diff = (Date.now() - d.getTime()) / 1000;
    if (diff < 60)     return 'Just now';
    if (diff < 3600)   return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400)  return `${Math.floor(diff / 3600)}h ago`;
    if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  } catch { return 'Just now'; }
};
const TYPE = {
  comment:    { label: 'Comment',    bg: '#DCFCE7', color: '#16A34A', dot: '#16A34A' },
  assignment: { label: 'Task',       bg: '#FEF3C7', color: '#D97706', dot: '#F59E0B' },
  general:    { label: 'General',    bg: '#DBEAFE', color: '#1D4ED8', dot: '#3B82F6' },
};
const avatarBg = (name = '') => {
  const p = ['#0D47A1','#1565C0','#1976D2','#16A34A','#D97706','#DC2626','#7C3AED','#DB2777','#0891B2'];
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) % p.length;
  return p[h];
};

const IcoBell    = ({ s = 20 }) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>;
const IcoComment = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>;
const IcoTask    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>;
const IcoGeneral = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>;
const IcoCheck   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>;
const IcoCheckAll= () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12"/><polyline points="14 6 3 17"/></svg>;
const IcoTrash   = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2"/></svg>;
const IcoClose   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IcoCreated = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>;
const IcoSpin    = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{animation:'nb-spin .8s linear infinite'}}><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>;
const typeIcon = (t) => t === 'comment' ? <IcoComment /> : t === 'assignment' ? <IcoTask /> : <IcoGeneral />;

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');
  .nb-wrap * { box-sizing:border-box; font-family:'DM Sans',sans-serif; }
  @keyframes nb-fadein { from{opacity:0;transform:translateY(-8px) scale(0.97)} to{opacity:1;transform:none} }
  @keyframes nb-shake  { 0%,100%{transform:rotate(0)} 20%{transform:rotate(14deg)} 40%{transform:rotate(-14deg)} 60%{transform:rotate(10deg)} 80%{transform:rotate(-6deg)} }
  @keyframes nb-pulse  { 0%,100%{transform:scale(1);opacity:1} 50%{transform:scale(1.5);opacity:.5} }
  @keyframes nb-blink  { 0%,100%{opacity:1} 50%{opacity:.3} }
  @keyframes nb-float  { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-8px)} }
  @keyframes nb-spin   { to{transform:rotate(360deg)} }
  @keyframes nb-slide  { from{opacity:0;transform:translateY(6px)} to{opacity:1;transform:none} }
  @keyframes nb-popin  { from{opacity:0;transform:scale(0.85)} to{opacity:1;transform:scale(1)} }
  .nb-bell { position:relative;width:42px;height:42px;border-radius:12px;border:none;background:transparent;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#1C2340;transition:all .2s; }
  .nb-bell:hover { background:rgba(13,71,161,.08);color:#0D47A1; }
  .nb-bell.shake { animation:nb-shake .6s ease; }
  .nb-badge { position:absolute;top:4px;right:4px;min-width:18px;height:18px;border-radius:9px;background:#EF4444;color:#fff;font-size:10px;font-weight:700;padding:0 5px;display:flex;align-items:center;justify-content:center;border:2px solid #fff;line-height:1; }
  .nb-panel { position:fixed;z-index:99999;width:400px;max-width:calc(100vw - 32px);max-height:calc(100vh - 80px);background:#fff;border-radius:18px;box-shadow:0 20px 60px rgba(0,0,0,.15),0 4px 16px rgba(0,0,0,.08);border:1px solid #E8EAF0;display:flex;flex-direction:column;overflow:hidden;animation:nb-fadein .22s cubic-bezier(.34,1.1,.64,1) both; }
  .nb-header { background:linear-gradient(135deg,#0D47A1,#1565C0);padding:16px 18px 14px;display:flex;align-items:center;justify-content:space-between;flex-shrink:0; }
  .nb-header-left { display:flex;align-items:center;gap:10px; }
  .nb-header-title { font-size:15px;font-weight:700;color:#fff; }
  .nb-header-sub   { font-size:11px;color:rgba(255,255,255,.65);margin-top:1px; }
  .nb-new-pill { display:flex;align-items:center;gap:5px;background:rgba(255,255,255,.18);backdrop-filter:blur(8px);color:#fff;padding:4px 10px;border-radius:20px;font-size:11px;font-weight:700; }
  .nb-new-dot  { width:6px;height:6px;border-radius:50%;background:#4ADE80;animation:nb-blink 1.5s infinite; }
  .nb-close-btn { width:28px;height:28px;border-radius:8px;border:none;cursor:pointer;background:rgba(255,255,255,.15);color:#fff;display:flex;align-items:center;justify-content:center;transition:all .15s; }
  .nb-close-btn:hover { background:rgba(255,255,255,.3); }
  .nb-stats { display:flex;align-items:center;gap:12px;padding:10px 16px;background:#F0F4FF;border-bottom:1px solid #E8EAF0;flex-shrink:0; }
  .nb-stat-item { display:flex;align-items:center;gap:5px; }
  .nb-stat-num  { font-size:15px;font-weight:800;color:#0D47A1; }
  .nb-stat-lbl  { font-size:11px;color:#64748B;font-weight:500; }
  .nb-stat-sep  { width:1px;height:16px;background:#CBD5E1; }
  .nb-tabs { display:flex;border-bottom:1px solid #F0F2F8;flex-shrink:0;background:#FAFBFD; }
  .nb-tab  { flex:1;padding:10px 4px;border:none;background:transparent;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:4px;font-family:'DM Sans',sans-serif;font-size:11px;font-weight:600;color:#7B829A;border-bottom:2px solid transparent;transition:all .15s;white-space:nowrap; }
  .nb-tab:hover  { color:#1C2340;background:rgba(13,71,161,.04); }
  .nb-tab.active { color:#0D47A1;border-bottom-color:#0D47A1;background:rgba(13,71,161,.04); }
  .nb-tab-count  { min-width:16px;height:16px;border-radius:8px;padding:0 4px;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700; }
  .nb-actions { display:flex;align-items:center;justify-content:space-between;padding:8px 14px;background:#F7F8FC;border-bottom:1px solid #F0F2F8;flex-shrink:0; }
  .nb-action-btn { display:flex;align-items:center;gap:5px;padding:5px 10px;border-radius:8px;border:none;cursor:pointer;font-family:'DM Sans',sans-serif;font-size:12px;font-weight:600;background:transparent;transition:all .15s; }
  .nb-action-btn.read  { color:#0D47A1; } .nb-action-btn.read:hover  { background:rgba(13,71,161,.08); }
  .nb-action-btn.clear { color:#EF4444; } .nb-action-btn.clear:hover { background:rgba(239,68,68,.08); }
  .nb-list { flex:1;overflow-y:auto;padding:10px;scrollbar-width:thin;scrollbar-color:#E2E8F0 transparent; }
  .nb-list::-webkit-scrollbar { width:4px; }
  .nb-list::-webkit-scrollbar-thumb { background:#E2E8F0;border-radius:4px; }
  .nb-item { display:flex;align-items:flex-start;gap:11px;padding:12px 13px;border-radius:12px;border:1.5px solid #F1F3F9;margin-bottom:7px;cursor:pointer;transition:all .18s;position:relative;background:#fff;animation:nb-slide .2s ease both; }
  .nb-item:last-child { margin-bottom:0; }
  .nb-item:hover { border-color:#D1D9F0;background:#F9FAFF;transform:translateX(3px); }
  .nb-item.unread { background:#F7F9FF;border-color:#DBEAFE; }
  .nb-item.unread:hover { background:#EEF3FF;border-color:#BFDBFE; }
  .nb-item.unread::before { content:'';position:absolute;left:0;top:8px;bottom:8px;width:3px;border-radius:0 3px 3px 0;background:#0D47A1; }
  .nb-avatar { width:40px;height:40px;border-radius:12px;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;color:#fff;letter-spacing:.5px; }
  .nb-item-body { flex:1;min-width:0; }
  .nb-item-top  { display:flex;align-items:center;gap:6px;margin-bottom:4px;flex-wrap:wrap; }
  .nb-item-name { font-size:13px;font-weight:700;color:#0F172A; }
  .nb-type-pill { display:inline-flex;align-items:center;gap:3px;padding:2px 8px;border-radius:20px;font-size:10px;font-weight:700;letter-spacing:.04em; }
  .nb-item-msg  { font-size:12.5px;color:#475569;line-height:1.5;margin-bottom:6px; }
  .nb-item-msg.unread { color:#1E293B;font-weight:500; }
  .nb-item-foot { display:flex;align-items:center;justify-content:space-between; }
  .nb-item-time { font-size:11px;color:#94A3B8;font-weight:500; }
  .nb-item-time.unread { color:#0D47A1;font-weight:600; }
  .nb-unread-dot { width:8px;height:8px;border-radius:50%;flex-shrink:0;margin-top:4px;animation:nb-pulse 2s infinite; }
  .nb-read-tick  { width:20px;height:20px;border-radius:50%;background:#DCFCE7;color:#16A34A;display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-top:2px; }
  .nb-load-more { display:flex;align-items:center;justify-content:center;gap:8px;padding:12px;color:#0D47A1;font-size:12px;font-weight:600; }
  .nb-empty { display:flex;flex-direction:column;align-items:center;justify-content:center;padding:44px 20px;color:#94A3B8;text-align:center;animation:nb-float 3s ease-in-out infinite; }
  .nb-empty-title { font-size:14px;font-weight:600;color:#64748B;margin:12px 0 4px; }
  .nb-empty-sub   { font-size:12px;color:#94A3B8; }
  .nb-footer { padding:9px 16px;border-top:1px solid #F0F2F8;background:#FAFBFD;flex-shrink:0;text-align:center;font-size:11px;color:#94A3B8;font-weight:500; }

  /* ── Transferred Toast ── */
  .nb-transferred-overlay { position:fixed;inset:0;z-index:999999;display:flex;align-items:center;justify-content:center;background:rgba(15,23,42,0.45);backdrop-filter:blur(4px); }
  .nb-transferred-card { background:#fff;border-radius:20px;padding:32px 28px;max-width:360px;width:calc(100vw - 40px);text-align:center;box-shadow:0 24px 60px rgba(0,0,0,.18);animation:nb-popin .25s cubic-bezier(.34,1.2,.64,1) both; }
  .nb-transferred-icon { width:64px;height:64px;border-radius:50%;background:linear-gradient(135deg,#FEF3C7,#FDE68A);display:flex;align-items:center;justify-content:center;margin:0 auto 16px; }
  .nb-transferred-title { font-size:16px;font-weight:800;color:#1E293B;margin-bottom:8px; }
  .nb-transferred-msg   { font-size:13px;color:#64748B;line-height:1.55;margin-bottom:20px; }
  .nb-transferred-btn   { display:inline-flex;align-items:center;justify-content:center;gap:6px;padding:10px 24px;border-radius:10px;border:none;cursor:pointer;background:#0D47A1;color:#fff;font-family:'DM Sans',sans-serif;font-size:13px;font-weight:700;transition:all .15s; }
  .nb-transferred-btn:hover { background:#1330A6; }
  .nb-checking-overlay { position:fixed;inset:0;z-index:999999;display:flex;align-items:center;justify-content:center;background:rgba(15,23,42,0.3);backdrop-filter:blur(2px); }
  .nb-checking-card { background:#fff;border-radius:14px;padding:20px 28px;display:flex;align-items:center;gap:12px;box-shadow:0 8px 32px rgba(0,0,0,.12); }
`;

const EmptyState = ({ tab }) => {
  const msgs = [
    { t:"You're all caught up!",    s:"No notifications yet" },
    { t:"No comment notifications", s:"Comments will appear here" },
    { t:"No task notifications",    s:"Assignments will appear here" },
    { t:"No activity from you yet", s:"Actions you took will show here" },
  ];
  const m = msgs[tab] || msgs[0];
  return (
    <div className="nb-empty">
      <div style={{ fontSize:40, opacity:.2 }}>🔔</div>
      <p className="nb-empty-title">{m.t}</p>
      <p className="nb-empty-sub">{m.s}</p>
    </div>
  );
};

// ── Transferred Lead Card ────────────────────────────────────────────────────
const TransferredCard = ({ leadName, onClose }) => createPortal(
  <div className="nb-transferred-overlay" onClick={onClose}>
    <div className="nb-transferred-card" onClick={e => e.stopPropagation()}>
      <div className="nb-transferred-icon">
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#D97706" strokeWidth="2" strokeLinecap="round">
          <path d="M17 16l4-4-4-4"/>
          <path d="M3 12h18"/>
          <path d="M7 8l-4 4 4 4"/>
        </svg>
      </div>
      <div className="nb-transferred-title">Lead Transferred</div>
      <div className="nb-transferred-msg">
        {leadName
          ? <><strong style={{color:'#1E293B'}}>{leadName}</strong> has been</>
          : 'This lead has been'
        }
        {' '}transferred from you to another sales representative and is no longer in your pipeline.
      </div>
      <button className="nb-transferred-btn" onClick={onClose}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
        Got it
      </button>
    </div>
  </div>,
  document.body
);

// ── Checking Overlay ─────────────────────────────────────────────────────────
const CheckingOverlay = () => createPortal(
  <div className="nb-checking-overlay">
    <div className="nb-checking-card">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0D47A1" strokeWidth="2.5" style={{animation:'nb-spin .8s linear infinite'}}>
        <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
      </svg>
      <span style={{fontSize:13, fontWeight:600, color:'#1E293B', fontFamily:"'DM Sans',sans-serif"}}>Checking lead...</span>
    </div>
  </div>,
  document.body
);

// ─────────────────────────────────────────────────────────────────────────────
const NotificationBell = () => {
  const [notifications,    setNotifications]    = useState([]);
  const [unreadCount,      setUnreadCount]      = useState(0);
  const [open,             setOpen]             = useState(false);
  const [selectedLead,     setSelectedLead]     = useState(null);
  const [shake,            setShake]            = useState(false);
  const [activeTab,        setActiveTab]        = useState(0);
  const [panelPos,         setPanelPos]         = useState({ top:0, right:16 });
  const [currentPage,      setCurrentPage]      = useState(1);
  const [totalResults,     setTotalResults]     = useState(0);
  const [hasNextPage,      setHasNextPage]      = useState(false);
  const [loadingMore,      setLoadingMore]      = useState(false);
  const [initialLoading,   setInitialLoading]   = useState(false);
  const [checking,         setChecking]         = useState(false);
  const [transferredLead,  setTransferredLead]  = useState(null);

  const bellRef  = useRef(null);
  const panelRef = useRef(null);
  const listRef  = useRef(null);

  const userRef = useRef(null);
  if (!userRef.current) {
    userRef.current = JSON.parse(localStorage.getItem('user') || '{}');
  }

  const uid        = userRef.current?.data?._id;
  const role       = userRef.current?.data?.role;
  const token      = userRef.current?.token || userRef.current?.data?.token || '';

  // ── Role flags ──────────────────────────────────────────────────────────────
  const isAdmin    = role === 'Admin';
  const isMarketer = role === 'Marketer';

  // ── Marketer channels: مصفوفة من الـ ids ────────────────────────────────────
  // بيدعم لو الـ channels عبارة عن objects { _id, name } أو strings مباشرة
  const marketerChannels = useMemo(() => {
    const raw = userRef.current?.data?.channels || [];
    return raw.map(c => (typeof c === 'object' && c !== null ? c._id || c : c)).filter(Boolean);
  }, []);

  // ── Build URL حسب الـ role ────────────────────────────────────────────────
  const buildUrl = useCallback((page) => {
    const base = `${db_url}api/v1/Notification?page=${page}&limit=${LIMIT}`;

    if (isAdmin) {
      // أدمن يشوف كل النوتيفيكيشنز
      return base;
    }

    if (isMarketer && marketerChannels.length > 0) {
      // ماركتير يشوف النوتيفيكيشنز الخاصة بـ leads channels بتاعته بس
      const ids = marketerChannels.join(',');
      return `${base}&marketerChannels=${ids}`;
    }

    // باقي الـ roles → بالـ receiver بس
    return `${base}&receiver=${uid}`;
  }, [isAdmin, isMarketer, marketerChannels, uid]);

  // ── Fetch page 1 ─────────────────────────────────────────────────────────
  const fetchPage1 = useCallback(async () => {
    setInitialLoading(true);
    try {
      const notifUrl  = buildUrl(1);

      // Unread URL نفس المنطق
      let unreadUrl;
      if (isAdmin) {
        unreadUrl = `${db_url}api/v1/Notification?page=1&limit=1&isRead=false`;
      } else if (isMarketer && marketerChannels.length > 0) {
        const ids = marketerChannels.join(',');
        unreadUrl = `${db_url}api/v1/Notification?page=1&limit=1&isRead=false&marketerChannels=${ids}`;
      } else {
        unreadUrl = `${db_url}api/v1/Notification?page=1&limit=1&isRead=false&receiver=${uid}`;
      }

      const [res, unreadRes] = await Promise.all([
        axios.get(notifUrl),
        axios.get(unreadUrl),
      ]);

      const body = res.data;
      const nots = (body?.data || []).filter(n => n?.message);
      const pg   = body?.pagination || {};

      setNotifications(nots);
      setCurrentPage(1);
      setTotalResults(pg.totalResults || nots.length);
      setHasNextPage(pg.hasNextPage || false);

      const realUnread =
        (pg?.unreadCount !== undefined ? pg.unreadCount : null) ??
        (unreadRes?.data?.pagination?.totalResults ?? null) ??
        nots.filter(n => !n.isRead).length;
      setUnreadCount(realUnread);

    } catch (e) {
      console.error('[NB] fetch error:', e);
      setNotifications([]);
    } finally {
      setInitialLoading(false);
    }
  }, [buildUrl, isAdmin, isMarketer, marketerChannels, uid]);

  useEffect(() => { fetchPage1(); }, [fetchPage1]);

  // ── Load more ─────────────────────────────────────────────────────────────
  const loadMore = useCallback(async () => {
    if (loadingMore || !hasNextPage) return;
    setLoadingMore(true);
    try {
      const res  = await axios.get(buildUrl(currentPage + 1));
      const body = res.data;
      const newN = (body?.data || []).filter(n => n?.message);
      const pg   = body?.pagination || {};
      setNotifications(prev => {
        const ids = new Set(prev.map(n => n._id));
        return [...prev, ...newN.filter(n => !ids.has(n._id))];
      });
      setCurrentPage(p => p + 1);
      setTotalResults(pg.totalResults || 0);
      setHasNextPage(pg.hasNextPage || false);
    } catch {}
    finally { setLoadingMore(false); }
  }, [loadingMore, hasNextPage, currentPage, buildUrl]);

  // ── Scroll to load more ───────────────────────────────────────────────────
  const handleScroll = useCallback(() => {
    const el = listRef.current;
    if (!el) return;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 100 && hasNextPage && !loadingMore)
      loadMore();
  }, [hasNextPage, loadingMore, loadMore]);

  useEffect(() => {
    const el = listRef.current;
    if (!el) return;
    el.addEventListener('scroll', handleScroll, { passive: true });
    return () => el.removeEventListener('scroll', handleScroll);
  }, [handleScroll, open]);

  // ── Socket: real-time notifications ──────────────────────────────────────
  useEffect(() => {
    const handler = (data) => {
      if (!data?.message) return;

      // ── للماركتير: تحقق إن الـ notification دي خاصة بـ lead في channels بتاعته
      if (isMarketer && marketerChannels.length > 0) {
        const leadChannel = data?.lead?.chanel;
        if (leadChannel) {
          const channelId = typeof leadChannel === 'object' ? leadChannel._id || leadChannel : leadChannel;
          const isMyChannel = marketerChannels.some(
            c => c.toString() === channelId.toString()
          );
          if (!isMyChannel) return; // مش channel بتاعته → تجاهل
        }
      }

      const isSender = data?.userdoaction?._id === uid;
      if (!isSender) {
        setUnreadCount(p => p + 1);
        setShake(true);
        setTimeout(() => setShake(false), 700);
      } else {
        data.isRead = true;
      }
      setNotifications(p => [data, ...p.filter(n => n._id !== data._id)]);
      setTotalResults(p => p + 1);
    };
    socket.on('newNotification', handler);
    return () => socket.off('newNotification', handler);
  }, [uid, isMarketer, marketerChannels]);

  // ── Close panel on outside click ─────────────────────────────────────────
  useEffect(() => {
    if (!open) return;
    const h = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target) &&
          bellRef.current  && !bellRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, [open]);

  // ── Open panel ────────────────────────────────────────────────────────────
  // ✅ كل مرة يُفتح فيها البانل، نجيب أحدث بيانات من السيرفر (بدل ما نعتمد بس على الـ socket)
  const openPanel = () => {
    if (bellRef.current) {
      const r = bellRef.current.getBoundingClientRect();
      setPanelPos({ top: r.bottom + 8, right: Math.max(16, window.innerWidth - r.right) });
    }
    setOpen(o => {
      const next = !o;
      if (next) {
        setActiveTab(0);
        fetchPage1(); // ✅ ريكويست جديد يجيب أحدث نوتيفيكيشنز
      }
      return next;
    });
  };

  // ── Filtered notifications per tab ───────────────────────────────────────
  // الـ Backend بيرجع البيانات المفلترة بالفعل حسب الـ role
  // الـ Frontend بيعمل sub-filter للـ tabs بس
  const filtered = useMemo(() => {
    if (!Array.isArray(notifications)) return [];

    // للأدمن: يشوف الكل
    // للماركتير: الـ backend رجّع الصح، مفيش فلتر إضافي هنا
    // لباقي الـ roles: الـ backend رجّع بالـ receiver، مفيش فلتر إضافي
    const base = notifications;

    switch (activeTab) {
      case 1: return base.filter(n => detectType(n.message) === 'comment');
      case 2: return base.filter(n => detectType(n.message) === 'assignment');
      case 3: return base.filter(n => n?.userdoaction?._id === uid);
      default: return base;
    }
  }, [notifications, activeTab, uid]);

  // ── Tab counts ────────────────────────────────────────────────────────────
  const counts = useMemo(() => {
    const base = notifications;
    return {
      all:         base.length,
      comments:    base.filter(n => detectType(n.message) === 'comment').length,
      assignments: base.filter(n => detectType(n.message) === 'assignment').length,
      created:     base.filter(n => n?.userdoaction?._id === uid).length,
    };
  }, [notifications, uid]);

  // ── Mark single as read ───────────────────────────────────────────────────
  const markAsRead = async (id) => {
    const notif = notifications.find(n => n._id === id);
    if (!notif || notif.isRead) return;
    // الماركتير ممكن يقرأ أي notification في نطاق channels بتاعته
    if (!isAdmin && !isMarketer && notif?.receiver?._id !== uid) return;
    try {
      await axios.put(`${db_url}api/v1/Notification/read/${id}`);
      setNotifications(p => p.map(n => n._id === id ? { ...n, isRead: true } : n));
      setUnreadCount(p => Math.max(0, p - 1));
    } catch { Notify('error', 'Failed', 'error'); }
  };

  // ── Click notification item ───────────────────────────────────────────────
  const handleNotifClick = async (notif) => {
    markAsRead(notif._id);

    const lead = notif?.lead;
    if (!lead?._id) return;

    // أدمن وماركتير → فتح اللييد مباشرة (الـ backend اتحقق بالفعل إنها في نطاقه)
    if (isAdmin || isMarketer) {
      setSelectedLead(lead);
      setOpen(false);
      return;
    }

    // باقي الـ roles → تحقق من الـ ownership
    setChecking(true);
    setOpen(false);

    try {
      const res = await axios.get(
        `${db_url}api/v1/users/sales/checknotifcationbeforeopen/${lead._id}/${uid}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const leadData = res.data?.data;
      setChecking(false);
      setSelectedLead(leadData || lead);
    } catch (err) {
      setChecking(false);
      if (err?.response?.status === 403) {
        setTransferredLead({ name: lead?.name || '' });
      } else {
        console.error('[NB] lead check error:', err);
        setSelectedLead(lead);
      }
    }
  };

  // ── Mark all read ─────────────────────────────────────────────────────────
  const markAllRead = async () => {
    try {
      let payload = {};

      if (isMarketer && marketerChannels.length > 0) {
        // الماركتير يمرر الـ channels عشان الـ backend يعرف إيه اللي يعمله read
        payload = { marketerChannels: marketerChannels.join(',') };
      } else if (!isAdmin) {
        payload = { receiver: uid };
      }

      await axios.put(`${db_url}api/v1/Notification/mark-all-read`, payload);
      setNotifications(p => p.map(n => ({ ...n, isRead: true })));
      setUnreadCount(0);
      Notify('success', 'All marked as read', 'success');
    } catch { Notify('error', 'Failed', 'error'); }
  };

  // ── Clear read ────────────────────────────────────────────────────────────
  const clearRead = async () => {
    try {
      let payload = {};

      if (isMarketer && marketerChannels.length > 0) {
        payload = { marketerChannels: marketerChannels.join(',') };
      } else if (!isAdmin) {
        payload = { receiver: uid };
      }

      await axios.delete(`${db_url}api/v1/Notification/clear`, { data: payload });

      // حذف الـ read notifications من الـ state
      if (isMarketer) {
        setNotifications(p => p.filter(n => !n.isRead));
      } else {
        setNotifications(p => p.filter(n => n.receiver?._id !== uid || !n.isRead));
      }

      Notify('success', 'Cleared', 'success');
    } catch { Notify('error', 'Failed', 'error'); }
  };

  // ── Tabs config ───────────────────────────────────────────────────────────
  const TABS = [
    { label:'All',         count:counts.all,         bg:'#DBEAFE', color:'#1D4ED8', icon:<IcoBell s={13}/> },
    { label:'Comments',    count:counts.comments,    bg:'#DCFCE7', color:'#16A34A', icon:<IcoComment/> },
    { label:'Assignments', count:counts.assignments, bg:'#FEF3C7', color:'#D97706', icon:<IcoTask/> },
    { label:'Created',     count:counts.created,     bg:'#F3E8FF', color:'#7C3AED', icon:<IcoCreated/> },
  ];

  // هل يظهر زر الـ actions (mark all / clear)؟
  // للماركتير يظهر زي باقي الـ roles
  const showActions = !isAdmin && activeTab === 0 && filtered.length > 0;

  return (
    <div className="nb-wrap">
      <style>{CSS}</style>

      {/* ── Bell button ── */}
      <button ref={bellRef} className={`nb-bell ${shake ? 'shake' : ''}`} onClick={openPanel} title="Notifications">
        <IcoBell s={20} />
        {unreadCount > 0 && <span className="nb-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>}
      </button>

      {/* ── Panel ── */}
      {open && createPortal(
        <div ref={panelRef} className="nb-panel" style={{ top:panelPos.top, right:panelPos.right }}>

          <div className="nb-header">
            <div className="nb-header-left">
              <IcoBell s={18} />
              <div>
                <div className="nb-header-title">Notifications</div>
                <div className="nb-header-sub">
                  {isMarketer ? 'My Channels Activity' : 'Activity Center'}
                </div>
              </div>
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:8 }}>
              {unreadCount > 0 && (
                <div className="nb-new-pill"><span className="nb-new-dot"/>{unreadCount} New</div>
              )}
              <button className="nb-close-btn" onClick={() => setOpen(false)}><IcoClose/></button>
            </div>
          </div>

          <div className="nb-stats">
            <div className="nb-stat-item">
              <span className="nb-stat-num">{totalResults}</span>
              <span className="nb-stat-lbl">Total</span>
            </div>
            <div className="nb-stat-sep"/>
            <div className="nb-stat-item">
              <span className="nb-stat-num" style={{color:'#EF4444'}}>{unreadCount}</span>
              <span className="nb-stat-lbl">Unread</span>
            </div>
            <div className="nb-stat-sep"/>
            <div className="nb-stat-item">
              <span className="nb-stat-num" style={{color:'#16A34A'}}>{totalResults - unreadCount}</span>
              <span className="nb-stat-lbl">Read</span>
            </div>
            <div style={{flex:1}}/>
            <div style={{fontSize:11, color:'#94A3B8'}}>{notifications.length} loaded</div>
          </div>

          <div className="nb-tabs">
            {TABS.map((t, i) => (
              <button key={i} className={`nb-tab ${activeTab === i ? 'active' : ''}`} onClick={() => setActiveTab(i)}>
                {t.icon} {t.label}
                {t.count > 0 && (
                  <span className="nb-tab-count" style={{background:t.bg, color:t.color}}>{t.count}</span>
                )}
              </button>
            ))}
          </div>

          {showActions && (
            <div className="nb-actions">
              <button className="nb-action-btn read"  onClick={markAllRead}><IcoCheckAll/> Mark all read</button>
              <button className="nb-action-btn clear" onClick={clearRead}><IcoTrash/> Clear read</button>
            </div>
          )}

          <div className="nb-list" ref={listRef}>
            {initialLoading ? (
              <div className="nb-load-more"><IcoSpin/> Loading...</div>
            ) : filtered.length === 0 ? (
              <EmptyState tab={activeTab} />
            ) : (
              <>
                {filtered.map(notif => {
                  if (!notif?.message) return null;
                  const t      = detectType(notif.message);
                  const cfg    = TYPE[t];
                  const isRead = notif.isRead;
                  const bg     = avatarBg(notif?.userdoaction?.name || '');
                  return (
                    <div
                      key={notif._id || Math.random()}
                      className={`nb-item ${!isRead ? 'unread' : ''}`}
                      onClick={() => handleNotifClick(notif)}
                    >
                      <div className="nb-avatar" style={{background: isRead ? '#E2E8F0' : bg, color: isRead ? '#64748B' : '#fff'}}>
                        {getInitials(notif?.userdoaction?.name)}
                      </div>
                      <div className="nb-item-body">
                        <div className="nb-item-top">
                          <span className="nb-item-name">{notif?.userdoaction?.name || 'System'}</span>
                          <span className="nb-type-pill" style={{background:cfg.bg, color:cfg.color}}>
                            {typeIcon(t)} {cfg.label}
                          </span>
                        </div>
                        <div className={`nb-item-msg ${!isRead ? 'unread' : ''}`}>{notif.message}</div>
                        {notif?.lead?.name && (
                          <div style={{display:'flex',alignItems:'center',gap:4,marginTop:4}}>
                            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                            <span style={{fontSize:11,color:'#94A3B8',fontWeight:500}}>{notif.lead.name}</span>
                            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#CBD5E1" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
                            <span style={{fontSize:11,color:'#60A5FA',fontWeight:600,cursor:'pointer'}}>Open lead</span>
                          </div>
                        )}
                        <div className="nb-item-foot">
                          <span className={`nb-item-time ${!isRead ? 'unread' : ''}`}>{formatDate(notif.createdAt)}</span>
                        </div>
                      </div>
                      {isRead
                        ? <div className="nb-read-tick"><IcoCheck/></div>
                        : <div className="nb-unread-dot" style={{background:cfg.dot}}/>
                      }
                    </div>
                  );
                })}
                {loadingMore && <div className="nb-load-more"><IcoSpin/> Loading more...</div>}
                {!hasNextPage && notifications.length > 0 && (
                  <div style={{textAlign:'center',padding:'12px 0',fontSize:11,color:'#CBD5E1',fontWeight:500}}>
                    All {totalResults} notifications loaded
                  </div>
                )}
              </>
            )}
          </div>

          {filtered.length > 0 && (
            <div className="nb-footer">
              Showing {notifications.length} of {totalResults} · {unreadCount} unread
            </div>
          )}

        </div>,
        document.body
      )}

      {/* ── Checking overlay ── */}
      {checking && <CheckingOverlay />}

      {/* ── Transferred card ── */}
      {transferredLead && (
        <TransferredCard
          leadName={transferredLead.name}
          onClose={() => setTransferredLead(null)}
        />
      )}

      {/* ── Lead modal ── */}
      {selectedLead && selectedLead._id && (
        <ShowClientsActionsAdvanced
          user={selectedLead}
          leadid={selectedLead._id}
          onClose={() => setSelectedLead(null)}
        />
      )}
    </div>
  );
};

export default NotificationBell;
